import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Возвращает параметры viewport.
 */
export const useViewport = () => {
  const theme = useTheme();

  // Референс по именам переменных: Window size classes из material design 3
  const isCompactView = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumView = useMediaQuery(theme.breakpoints.down('md'));
  const isExpandedView = useMediaQuery(theme.breakpoints.up('md'));

  const isPrintView = useMediaQuery('print');

  return {
    isCompactView,
    isMediumView,
    isExpandedView,
    isPrintView,
  } as const;
};
